type Props = { snippet: string };

export default function ServerEmbed({ snippet }: Props) {
  return (
    <div
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Embed code is trusted from CMS
      dangerouslySetInnerHTML={{ __html: snippet }}
      style={{ height: '100%' }}
      data-testid='server-embed'
    />
  );
}
